import { Tooltip } from "react-tooltip"
import { browserStyles, browserToScreenRatio } from "../constants"
import { keys, map } from "lodash"

export const DigitalSignage = props => {
  const {
    showDigitalSignage = false,
    digitalSignage,
    onShowSignageChange = () => {},
    onOptionsChange = () => {},
    disabled = false
  } = props

  return (
    <div className={disabled ? 'area-disabled' : ''}>
      <h4>Digital Signage Options</h4>

      <div className="row mb-4 align-items-center">
        <div className="col-sm-5">Allow Digital signage</div>
        <div className="col-sm-7">
          <select
            className="form-control"
            value={showDigitalSignage ? '1' : '0'}
            onChange={e => onShowSignageChange(!!Number(e.target.value))}
            disabled={disabled}
          >
            <option value="1">Yes</option>
            <option value="0" selected>No</option>
          </select>
        </div>
      </div>

      {
        showDigitalSignage && (
          <>
            <div className="row mb-4 align-items-center">
              <div className="col-sm-5">URL for Digital Signage</div>
              <div className="col-sm-7 d-flex justify-content-end">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter url for digital signage"
                  value={digitalSignage?.url}
                  onChange={e => onOptionsChange({...digitalSignage, url: e.target.value})}
                />
              </div>
            </div>
            <div className="row mb-4 align-items-center">
              <div className="col-sm-5">Timer till digital signage</div>
              <div className="col-sm-7 d-flex justify-content-end">
                <input
                  type="number"
                  className="form-control"
                  placeholder="Idle time(minutes) to show digital signage"
                  value={digitalSignage?.timerTill}
                  onChange={e => onOptionsChange({...digitalSignage, timerTill: Number(e.target.value)})}
                />
              </div>
            </div>

            <div className="row mb-4 align-items-center">
              <div className="col-sm-5">Duration of digital signage</div>
              <div className="col-sm-7">
                <input
                  type="number"
                  className="form-control"
                  placeholder="Digital signage duration(minutes)"
                  value={digitalSignage?.duration}
                  onChange={e => onOptionsChange({...digitalSignage, duration: Number(e.target.value)})}
                />
              </div>
            </div>

            <div className="row mb-4 align-items-center">
              <div className="col-sm-5">Signage style</div>
              <div className="col-sm-7">
                <select
                  className="form-control"
                  value={digitalSignage?.signageStyle}
                  onChange={e => onOptionsChange({...digitalSignage, signageStyle: e.target.value})}
                >
                  <option value={browserStyles.overlay}>Overlay</option>
                  <option value={browserStyles.sideBySide}>Side-by-Side</option>
                  <option value={browserStyles.replace}>Replace</option>
                </select>
              </div>
            </div>

            {digitalSignage.signageStyle === browserStyles.sideBySide && (
              <div className="row mb-4 align-items-center">
                <div className="col-sm-5">
                  Digital Signage to screen ratio
                  <i data-tooltip-id="digital-signage-screen-ratio-info" className="fa fa-info-circle ml-2"></i>
                  <Tooltip
                    id="digital-signage-screen-ratio-info"
                    place="top"
                    content="Signage:Video Window view scale. i.e. 1:1 is equal to 50-50% for each."
                  />
                </div>
                <div className="col-sm-7">
                  <select
                    className="form-control"
                    value={digitalSignage.signageToScreenRatio}
                    onChange={e => onOptionsChange({...digitalSignage, signageToScreenRatio: e.target.value})}
                  >
                    {map(keys(browserToScreenRatio), (key, j) => (
                      <option key={`${j}-${key}`} value={key}>
                        {browserToScreenRatio[key]}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}

            <div className="row mb-4 align-items-center">
              <div className="col-sm-5">Show Digital signage when odd pairing</div>
              <div className="col-sm-7">
                <select
                  className="form-control"
                  value={digitalSignage?.showByOddPairing ? '1' : '0'}
                  onChange={e => onOptionsChange({...digitalSignage, showByOddPairing: Number(e.target.value)})}
                >
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </select>
              </div>
            </div>

            {
              digitalSignage?.showByOddPairing ? <div className="row mb-4 align-items-center">
                <div className="col-sm-5">URL for Odd pairing digital signage</div>
                <div className="col-sm-7 d-flex justify-content-end">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter url for odd pairing digital signage"
                    value={digitalSignage?.oddPairingUrl}
                    onChange={e => onOptionsChange({...digitalSignage, oddPairingUrl: e.target.value})}
                  />
                </div>
              </div> : null
            }

            <div className="row mb-4 align-items-center">
              <div className="col-sm-5">Show Digital signage when sleep mode</div>
              <div className="col-sm-7">
                <select
                  className="form-control"
                  value={digitalSignage?.showOnSleepMode ? '1' : '0'}
                  onChange={e => onOptionsChange({...digitalSignage, showOnSleepMode: Number(e.target.value)})}
                >
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </select>
              </div>
            </div>

            {
              digitalSignage?.showOnSleepMode ? <div className="row mb-4 align-items-center">
                <div className="col-sm-5">URL for Sleep mode digital signage</div>
                <div className="col-sm-7 d-flex justify-content-end">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter url for sleep mode digital signage"
                    value={digitalSignage?.sleepModeUrl}
                    onChange={e => onOptionsChange({...digitalSignage, sleepModeUrl: e.target.value})}
                  />
                </div>
              </div> : null
            }
          </>
        )
      }
    </div>
  )
}
